exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-pasos {\n  /*border: 1px solid #ccc;*/\n  border-radius: 100%;\n  width: 18px;\n  height: 17px;\n  font-size: 1.4em;\n  text-align: center;\n  line-height: 17px;\n  background-color: #EBEAEB;\n  /*font-weight: 800;*/\n  color: #333;\n  /*text-decoration: underline;*/\n  /*box-shadow: 2px 2px 5px #000;*/\n  margin-left: 0px;\n  background: radial-gradient(circle at 8px 8px, white, white);\n  margin-bottom: 33px; }\n\n.glyphicon {\n  position: relative;\n  display: inline-block;\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: 100;\n  color: black;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.left-margin {\n  margin-left: auto !important; }\n\n.right-margin {\n  margin-right: auto; }\n\n.border {\n  border-left: 1px;\n  border-left-color: white;\n  border-left-style: solid;\n  padding-bottom: 8px;\n  padding-top: 8px;\n  margin-left: 15px; }\n\n.logo-juego {\n  width: 243px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/shared/simple-header/simple-header.scss
// module id = ../../../../../src/app/layouts/shared/simple-header/simple-header.scss
// module chunks = 6